import { createContactNumberValidator } from 'utils'
import { object, string } from 'yup'

export const schema = object().shape({
	contact_number: createContactNumberValidator('contact_number', string()),
})
